/**
 * PageHeader — the unified header for every Sayz panel page.
 *
 * Structure:
 *   [ico] Title (h1)
 *         Description (max-w-2xl, muted)                            [actions →]
 *
 * Contract:
 *   - `icon`      lucide Icon component (rendered inside a 9×9 rounded chip)
 *   - `title`     page name (uses font-display, bold, 2xl→3xl responsive)
 *   - `description` optional single-paragraph subtitle
 *   - `actions`   right-aligned React node (usually one primary + optional secondary button)
 *   - `testId`    optional data-testid for the wrapper
 */
export function PageHeader({ icon: Icon, title, description, actions, testId }) {
    return (
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3" data-testid={testId}>
            <div className="min-w-0">
                <div className="flex items-center gap-2.5">
                    <div className="h-9 w-9 rounded-lg border border-border bg-muted/40 grid place-items-center shrink-0">
                        {Icon && <Icon className="h-4 w-4" strokeWidth={1.75} />}
                    </div>
                    <h1 className="font-display text-2xl md:text-3xl font-bold tracking-tight">{title}</h1>
                </div>
                {description && (
                    <p className="text-sm text-muted-foreground mt-2 max-w-2xl leading-relaxed">{description}</p>
                )}
            </div>
            {actions && <div className="flex flex-wrap items-center gap-2 md:shrink-0">{actions}</div>}
        </div>
    );
}
